module.exports = __webpack_public_path__ + "img/2.70c3c353.png";